import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import type { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';
import { RoomService } from '@zaoblako/web/core/services/catalog/room.service';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { MultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/multi-select/multi-select.component';

@Component({
  selector: 'crm-room-multi-select',
  standalone: true,
  imports: [CommonModule, MultiSelectComponent],
  templateUrl: './room-multi-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoomMultiSelectComponent implements OnInit, OnDestroy {
  @Input() public rooms: RoomFindInterface[] = [];

  @Input() public selectedRooms: RoomFindInterface[] = [];
  @Output() public selectedRoomsChange = new EventEmitter<RoomFindInterface[]>();

  @Input() public autoSelectOne = false;
  @Input() public isHaveConverters = false;
  @Input() public onlyAvailable = false;
  @Input() public onlyWithHikvisionCameras = false;

  @Input() public customRequest = false;
  @Input() public sort: string;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public showClear = true;
  @Input() public disabled = false;
  @Input() public isError = false;
  @Input() public isFloatLabel = true;
  @Input() public placeholder = '\u00A0';
  @Input() public display = 'chip';
  @Input() public appendTo: string;

  private loadedRooms = false;
  private timer: NodeJS.Timer;

  @Input() public set setSelectedRoomIds(ids: number[]) {
    if (ids?.length) {
      ids.forEach((id, index) => {
        if (typeof id === 'string') {
          ids[index] = +id;
        }
      });
    }

    if (
      ids?.length &&
      ((this.selectedRooms?.length && !this.selectedRooms?.every((selectedRoom) => ids.includes(selectedRoom.id))) ||
        !this.selectedRooms?.length)
    ) {
      if (this.loadedRooms) {
        this.selectedRooms = this.rooms.filter((room) => ids.includes(room.id));
      } else {
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
          if (this.loadedRooms) {
            this.selectedRooms = this.rooms.filter((room) => ids.includes(room.id));
            this.cdRef.markForCheck();
            clearInterval(this.timer);
          }
        }, 500);
      }
    }
  }

  public constructor(
    private readonly roomService: RoomService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly globalService: GlobalService
  ) {}

  public ngOnInit(): void {
    if (
      !this.customRequest &&
      (this.globalService.globalInfo.tenantInfo?.ratePlan?.availableModules || []).includes('BASIS')
    ) {
      this.roomService
        .findAll({
          isHaveConverters: this.isHaveConverters,
          onlyAvailable: this.onlyAvailable,
          onlyWithHikvisionCameras: this.onlyWithHikvisionCameras
        })
        .subscribe({
          next: (rooms) => {
            this.rooms = rooms;

            if (this.autoSelectOne && this.rooms?.length === 1 && !this.selectedRooms?.length) {
              this.selectedRooms = this.rooms;
              this.selectedRoomsChange.emit(this.selectedRooms);
            }

            this.loadedRooms = true;
            this.cdRef.markForCheck();
          },
          error: () => {
            if (this.timer) {
              clearInterval(this.timer);
            }
          }
        });
    } else {
      this.loadedRooms = true;
    }
  }

  public ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
